import { render, staticRenderFns } from "./User_show.vue?vue&type=template&id=1a8a8138&scoped=true&"
import script from "./User_show.vue?vue&type=script&lang=js&"
export * from "./User_show.vue?vue&type=script&lang=js&"
import style0 from "./User_show.vue?vue&type=style&index=0&id=1a8a8138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a8138",
  null
  
)

export default component.exports